import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { initState, resetState } from './actions.js';
import isEmpty from 'lodash/isEmpty';

class ReduxInstance {
  constructor() {
    this.reducers = {};
    this.initialState = {};
    this.listenerMiddleware = createListenerMiddleware();
    this.init(this.reducers);
  }

  init(reducers, state) {
    const appReducer = !isEmpty(reducers) ? combineReducers(reducers) : reducer => reducer;
    this.storeInstance = configureStore({
      reducer: this.createRootReducer(appReducer),
      preloadedState: this.initialState,
      devTools: process.env.NODE_ENV === 'development',
      middleware: getDefaultMiddleware =>
        getDefaultMiddleware().prepend(this.listenerMiddleware.middleware),
    });
    this.initialState = state || {};
    this.reducers = reducers;
  }

  createRootReducer(appReducer) {
    return (state, action) => {
      switch (action.type) {
        case `${initState}`:
          return action.payload;
        case `${resetState}`:
          return this.initialState;
        default:
          return appReducer(state, action);
      }
    };
  }

  injectReducer(key, reducer) {
    this.reducers[key] = reducer;

    const newReducers = { ...this.reducers, [key]: reducer };
    if (!this.initialized) {
      this.init(newReducers);
    } else {
      this.storeInstance.replaceReducer(this.createRootReducer(combineReducers(newReducers)));
      this.initialState = { ...this.initialState, [key]: this.storeInstance.getState() };
    }
  }

  get initialized() {
    return !!this.storeInstance;
  }

  get store() {
    return this.storeInstance;
  }

  get listener() {
    return this.listenerMiddleware;
  }
}

const reduxInstance = new ReduxInstance();
export default reduxInstance;
